<template>
  <div>
    <topbar
      :titulo="$t('ACADEMICO.GERENCIADOR_TURMAS')"
      :subtitulo="$t('ACADEMICO.GERENCIADOR_TURMAS_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    />

    <!-- filtro -->
    <filtro
      :refiltrar="filtro.refiltrar"
      @resultado="getFiltro"
      @limparFiltro="limparFiltro"
    />

    <div class="accordion mt-5" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-AlunosSemTurma variant="info">
            Alunos sem turma
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-AlunosSemTurma"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <TabelaAlunosSemTurma
              :refiltrar="filtro.refiltrar"
              :items="itemsFiltro.alunosNaoEnturmados"
              @ensalar="abrirModalEnsalamento"
              @enturmar-varios-alunos="abrirModalEnturmarVariosAlunos"
              :alunosSemTurma="true"
            />
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- turmas -->
      <b-card
        v-for="resultado in itemsFiltro.turmas"
        :key="resultado.turmaId"
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            v-b-toggle="`accordion-` + resultado.turmaId"
            variant="info"
          >
            {{ resultado.turmaDescricao }}
          </b-button>
        </b-card-header>
        <b-collapse
          :id="`accordion-` + resultado.turmaId"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <tabela-turmas
              :items="resultado.alunosEnturmados"
              @ensalar="abrirModalEnsalamento"
              @atualiza-tabela="atualizarTabela"
              @alterar-ordenacao="novaOrdenacaoTabelaTurmas"
            />
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>    <!-- modal -->
    <modal-ensalamento
      :exibir="modais.ensalamento"
      :form="modais.ensalamentoDados"
      :variosAlunos="variosAlunos"
      @enturmar-alunos="enturmarVariosAlunos"
      @atualiza-tabela="atualizarTabela"
      @fechar="fecharModalEnsalamento"
    />
  </div>
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Filtro from './components/Filtro.vue';
import TabelaTurmas from './components/TabelaTurmas.vue';
import TabelaAlunosSemTurma from './components/TabelaAlunosSemTurma.vue';
import ModalEnsalamento from './components/Modal.vue';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import TurmaService from '@/common/services/academico/turma.service';

export default {
  components: {
    Topbar,
    Filtro,
    TabelaTurmas,
    TabelaAlunosSemTurma,
    ModalEnsalamento,
  },
  data() {
    return {
      variosAlunos: false,
      filtro: {
        refiltrar: false,
      },
      alunosSelecionados: [],
      itemsFiltro: [],
      modais: {
        ensalamento: false,
        ensalamentoDados: {},
      },
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO.GERENCIADOR_TURMAS') },
      ],
    };
  },
  methods: {
    enturmarVariosAlunos(turmaId) {
      let contratosIds = [];
      this.alunosSelecionados.forEach((item) => {
        contratosIds.push(item.contratoId);
      });
      let formVariosAlunos = {
        turmaId: turmaId,
        contratosId: contratosIds,
      };

      this.$store.dispatch(START_LOADING);
      TurmaService.enturmarAluno(formVariosAlunos)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Alunos enturmados!');
          this.atualizarTabela();
          this.modais.ensalamento = false;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    abrirModalEnturmarVariosAlunos(alunosSelecionados) {
      this.alunosSelecionados = alunosSelecionados;
      this.variosAlunos = true;
      this.modais.ensalamento = true;
      this.modais.ensalamentoDados = JSON.parse(
        JSON.stringify(alunosSelecionados[0])
      );
    },
    getFiltro(resultadoFiltro) {
      return (this.itemsFiltro = resultadoFiltro);
    },
    limparFiltro() {
      this.itemsFiltro = [];
    },
    atualizarTabela() {
      this.filtro.refiltrar == false
        ? (this.filtro.refiltrar = true)
        : (this.filtro.refiltrar = false);
    },
    abrirModalEnsalamento(_, item = {}) {
      this.variosAlunos = false;
      this.modais.ensalamento = true;

      this.modais.ensalamentoDados = item;
    },
    fecharModalEnsalamento() {
      this.modais.ensalamento = false;
    },
    novaOrdenacaoTabelaTurmas(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
    },
  },
};
</script>
